import { Link } from "react-router-dom";
import { Anchor, Paper, Space, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { TermsLayout } from "../../layouts/TermsLayout";
import { useTranslation } from "react-i18next";

export const TermsOfService = () => {
  const matches = useMediaQuery("(max-width: 485px)");
  const { t } = useTranslation();

  return (
    <TermsLayout>
      <Title size={matches ? 36 : 48}>{t("terms_of_service_title")}</Title>
      <Text>{t("effective_date")}: 6th of July, 2024</Text>
      <Space h={matches ? 40 : 80} />
      <Paper bg="#000" p="xl" c="#fff" radius={16} px={16} py={16}>
        <Text ta="start">{t("welcome_message")}</Text>
        <br />
        <Text ta="start">
          {t("email_label")}:{" "}
          <Anchor
            c="#DE57CC"
            to="mailto:ahello@competenzlab.com"
            component={Link}
          >
            ahello@competenzlab.com
          </Anchor>
        </Text>
        <Text ta="start">
          {t("address_label")}: <Anchor c="#6F40E2">{t("address")}</Anchor>
        </Text>
      </Paper>

      <Space h={matches ? 40 : 80} />
      <Text ta="start">
        {t("terms_binding_contract_1")}
        {t("terms_binding_contract_2")}
        <br /> <br />
        {t("terms_read_carefully_1")}
        {t("terms_read_carefully_2")}
        {t("terms_read_carefully_3")}
        {t("terms_read_carefully_4")}
        <br /> <br />
      </Text>
      <br />
      <Title size={36} ta="start">
        {t("terms_change_question")}
      </Title>
      <br />
      <Text ta="start">
        {t("terms_change_info_1")}
        {t("terms_change_info_2")}
        <br /> <br />
        {t("terms_change_rejection")}
      </Text>

      <br />
      <Title size={36} ta="start">
        {t("privacy_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("privacy_message")}{" "}
        <Anchor
          c="#DE57CC"
          to="https://competenzlab.com/privacy-policy"
          component={Link}
        >
          {t("privacy_policy_link")}
        </Anchor>
      </Text>
      <br />
      <Title size={24} ta="start">
        {t("coppa_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("coppa_message_1")}
        {t("coppa_message_2")}
        {t("coppa_message_3")}
        {t("coppa_message_4")}
        {t("coppa_contact_label")}{" "}
        <Anchor c="#DE57CC" to="mailto:hello@competenzlab.com" component={Link}>
          hello@competenzlab.com
        </Anchor>
        .
      </Text>

      <br />
      <Title size={36} ta="start">
        {t("basics_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("basics_message_1")}
        {t("basics_message_2")}
        <br /> <br />
        {t("basics_message_3")}
        <br /> <br />
        {t("basics_message_4")}
      </Text>

      <br />
      <Title size={36} ta="start">
        {t("messaging_title")}
      </Title>
      <br />
      <Text ta="start">{t("messaging_message")}</Text>
      <br />
      <Title size={36} ta="start">
        {t("rights_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("rights_message_1")}
        {t("rights_message_2")}
        {t("rights_message_3")}
        {t("rights_message_4")}
        {t("rights_message_5")}
      </Text>

      <br />
      <Title size={36} ta="start">
        {t("user_contribution_title")}
      </Title>
      <br />
      <Title size={24} ta="start">
        {t("user_submissions_title")}
      </Title>
      <br />
      <Text ta="start">{t("user_submission_message")}</Text>
      <br />
      <Title size={24} ta="start">
        {t("licenses_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("licenses_message_1")}
        <br />
        {t("licenses_message_2")}
        <br />
        {t("licenses_message_3")}
        <br />
        {t("licenses_message_4")}
        <br />
        {t("licenses_message_5")}
        <br />
      </Text>

      <br />
      <Title size={24} ta="start">
        {t("responsibility_title")}
      </Title>
      <br />
      <Text ta="start">
        {t("responsibility_message_1")}
        <br />
        {t("responsibility_message_2")}
        <br />
        {t("responsibility_message_3")}
        <br />
        {t("responsibility_message_4")}
        <br />
        {t("responsibility_message_5")}
        <br />
        {t("responsibility_message_6")}
        <br />
      </Text>
    </TermsLayout>
  );
};
